import { createSlice } from "@reduxjs/toolkit";
import cookie from "js-cookie";

//const NOTLOGGEDIN = null;
const LOGGEDIN = 1;
const REGISTER = 2;
const VERIFYEMAIL = 3;
const PENDING2FA = 4;

const initialStateValue = { tokenType: null, userType: null/*, isLoggedIn: false*/};

export const userSlice = createSlice({
  name: "user",
  initialState: () => {
    if(cookie.get('token')){
      //console.log(cookie.get('token'));
      let type = (cookie.get('token').endsWith("--P"))?'provider':'user';
      if(cookie.get('token').startsWith("R--")) {
        return {value: {tokenType: REGISTER, userType: type}};
      } else if(cookie.get('token').startsWith("V--")) {
        return {value: {tokenType: VERIFYEMAIL, userType: type}};
      } else if(cookie.get('token').startsWith("P--")) {
        return {value: {tokenType: PENDING2FA, userType: type}};
      } else {
        return {value: {tokenType: LOGGEDIN, userType: type}};
      }
    }else{
      return {value: initialStateValue};
    }
  },
  reducers: {
    register: (state, action) => {
      //console.log("reducers register");
      state.value.tokenType = REGISTER;
      if(action.payload.userType === 'provider') {state.value.userType='provider'};
      cookie.set('token', "R--"+action.payload.token+(action.payload.userType === 'provider'?'--P':''), { sameSite: 'strict', expires: 365 });
    },

    verifyEmail: (state, action) => {
      //console.log("reducers register");
      state.value.tokenType = VERIFYEMAIL;
      if(action.payload.userType === 'provider') {state.value.userType='provider'};
      cookie.set('token', "V--"+action.payload.token+(action.payload.userType === 'provider'?'--P':''), { sameSite: 'strict', expires: 365 });
    },

    login: (state, action) => {
      state.value.tokenType = LOGGEDIN;
      if(action.payload.userType === 'provider') {state.value.userType='provider'};
      cookie.set('token', action.payload.token+(action.payload.userType === 'provider'?'--P':''), { sameSite: 'strict', expires: 365 });
      //cookie.set('is_logged_in', '1');
    },

    pending2FA: (state, action) => {
      state.value.tokenType = PENDING2FA;
      if(action.payload.userType === 'provider') {state.value.userType='provider'};
      cookie.set('token', "P--"+action.payload.token+(action.payload.userType === 'provider'?'--P':''), { sameSite: 'strict', expires: 365 });
    },

    logout: (state) => {
      state.value = initialStateValue;
      cookie.remove('token', { sameSite: 'strict', expires: 365 }); //, { sameSite: 'strict' }
      //cookie.remove('is_logged_in');
    },
  },
});

export const { register, verifyEmail, login, pending2FA, logout } = userSlice.actions;

export default userSlice.reducer;

export const isRegister = (state) => state?.user?.value?.tokenType === REGISTER;
export const isVerifyEmail = (state) => state?.user?.value?.tokenType === VERIFYEMAIL;
export const isLoggedIn = (state) => state?.user?.value?.tokenType === LOGGEDIN;
export const isPending2FA = (state) => state?.user?.value?.tokenType === PENDING2FA;
export const isProvider = (state) => state?.user?.value?.userType === 'provider';
  //state.posts.posts.find(post => post.id === postId);

export const userToken = () => cookie.get('token')?cookie.get('token').replace("R--" ,"").replace("V--" ,"").replace("P--" ,"").replace("--P" ,""):null;
